module.exports = __webpack_public_path__ + "pc-top-assets/img/arrow.efcbcb59.svg";